module.exports = {"vesselName":"","vessel":"","items":[],"user":"","validateErrors":[],"successMessage":{},"loadingPortName":""}


//////////////////
// WEBPACK FOOTER
// ./app/mocks/vessel/size.json
// module id = 687
// module chunks = 0